import moment from 'moment';
import { getData_Vehicle } from '@/components/report/service';
import { computeWeightNotAbs, computeWeights } from '@/utils/query';
import {
  PlanDepartureStockQuery,
  PlanDepartureNextSiteQuery,
  actualDepartureQuery,
  PlanDepartureBasise,
} from '../Tables/PlanDepartureTable/Sql';
import { aggreArrItem, groupBys } from '@/utils/columnSearch';
import lodash from 'lodash';
import {
  getBelongCenterForOperatingArea,
  getOperatingAreaChildCenter,
  getProvinceId,
} from '@/services/area';

export default {
  namespace: 'centerWeightViewDepartTablesTest2',
  state: {
    tableItem: [],
    page: 1,
    totalRow: {},
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      yield put({ type: 'getPlanDeparture' });
    },
    /**
     * 干线预计出发货量
     */
    *getPlanDeparture(_, { call, put, select }) {
      let query = yield select(({ centerWeightView2Test2 }) => {
        return {
          // datadbName,actualDepartureCarsItem, planDepartureCarsItem, volumeItem, centerFilter, centerCode,
          ...centerWeightView2Test2,
          startDate: moment(centerWeightView2Test2.dateRange[0]).format(
            centerWeightView2Test2.defualtDateFormat,
          ),
          endDate: moment(centerWeightView2Test2.dateRange[1]).format(
            centerWeightView2Test2.defualtDateFormat,
          ),
          currentStartTime:
            centerWeightView2Test2.crrentDateRange &&
            moment(centerWeightView2Test2.crrentDateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
          currentEndTime:
            centerWeightView2Test2.crrentDateRange &&
            moment(centerWeightView2Test2.crrentDateRange[1]).format('YYYY-MM-DD HH:mm:ss'),
        };
      });

      let scanSiteNames = null,
        nextSiteNames = null;
      if (
        query.searchParams.departProvinceArea?.name ||
        query.searchParams.departProvinceAreaSelect?.label
      ) {
        const operatingAreaChilds = yield getOperatingAreaChildCenter(
          query.access.isArea
            ? query.searchParams.departProvinceAreaSelect?.value
            : query.searchParams.departProvinceArea.code,
        );
        scanSiteNames = operatingAreaChilds?.map((item) => item.siteName);
      }
      if (query.searchParams.arrivalProvinceArea?.name) {
        const operatingAreaChilds = yield getOperatingAreaChildCenter(
          query.searchParams.arrivalProvinceArea.code,
        );
        nextSiteNames = operatingAreaChilds?.map((item) => item.siteName);
      }

      //#region 获取出发分拨集合
      // let scanSiteArr = [query.centerFilter]
      let filter = {};
      // if (!query.centerFilter) {
      //   filter = PlanProvenceGetNext({
      //     startDate: query.startDate,
      //     endDate: query.endDate,
      //     scanProvinceArea: query.searchParams.departProvinceArea.name,
      //     nextProvinceArea: query.searchParams.arrivalProvinceArea.name
      //   })
      //   const data = yield call(getData_Vehicle, filter, query.datadbName);
      //   scanSiteArr = Object.keys(groupBys(data, 'scanSite'))
      // }
      // query.centerFilter = scanSiteArr
      //#endregion
      // 查询本站(省区则为多个)出发,所有下一站
      filter = PlanDepartureBasise({
        scanSiteCode: query.searchParams.departCenter?.code,
        startDate: query.startDate,
        endDate: query.endDate,
        // scanProvinceArea: query.searchParams.departProvinceArea?.name,
        scanProvinceArea: scanSiteNames,
        // nextProvinceArea: query.searchParams.arrivalProvinceArea?.name
        nextProvinceArea: nextSiteNames,
      });
      const allSite = yield call(getData_Vehicle, filter, query.datadbName);
      let nextOperatingAreas = new Map(); // 下一站营运区集合
      // 出发、到达网点数据集合
      if (allSite.length > 0) {
        // 网点数据
        const nextSites = new Set();
        const scanSites = new Set();

        const nextSiteCodes = new Set();
        const scanSiteCodes = new Set();
        allSite.forEach((item) => {
          // Set排除重复项
          nextSites.add(item.nextSite);
          scanSites.add(item.scanSite);

          nextSiteCodes.add(item.nextSiteCode);
          scanSiteCodes.add(item.scanSiteCode);
        });

        // 获取下一站营运区
        nextOperatingAreas = yield getBelongCenterForOperatingArea(Array.from(nextSites));

        let scanSiteArr = [...scanSiteCodes];
        const flowQuery = {
          scanSiteCodes: scanSiteArr,
          startDate: query.startDate,
          endDate: query.endDate,
          nextSiteCodes: [...nextSiteCodes],
          currentStartTime: query.currentStartTime,
          currentEndTime: query.currentEndTime,
        };

        const results = [];
        const filter2 = PlanDepartureNextSiteQuery(flowQuery);
        // 网点/中转/库存数据
        const fetchAll = filter2.map((filter) => getData_Vehicle(filter, query.datadbName));
        const fetchResult = yield Promise.all(fetchAll);
        for (let i = 0; i < fetchResult.length; i++) {
          const d = fetchResult[i];
          // 将实际装车的计划planNextSite赋值给nextSite,方便处理数据
          if (d && (i === 5 || i === 7)) {
            d.forEach((item) => {
              item.nextSite = item.planNextSite;
            });
          }
          results.push(d || []);
        }
        //#region 天象库存
        // let maxStockData = []
        // if (query.centerCode) {
        //   const param = {
        //     centerCode: query.centerCode,
        //     centerName: query.centerFilter,
        //     nextSiteType: '60',
        //     beginTime: moment(query.startDate).format('YYYY-MM-DD HH:mm:ss'),
        //     endTime: moment(query.endDate).format('YYYY-MM-DD HH:mm:ss'),
        //   }
        //   let maxData = yield crudRequest(
        //     '/api/v1/stock/realtime/stockInfo', param,
        //     { module: 'maxcenterbusi' }
        //   )
        //   if (maxData?.data) {
        //     maxStockData = maxData.data.map(m => {
        //       m.nextSite = m.nextSiteName
        //       return m
        //     })
        //   }
        // }
        //#endregion

        //#region 按天统计表_库存
        //#region 数据拼接
        // 获取实际发车,计划发车任务号
        const actualCars = [],
          planCars = [];
        for (let i = 0; i < scanSiteArr.length; i++) {
          const scanSite = scanSiteArr[i];
          const { actualDepartureCarsItem, planDepartureCarsItem } = yield put.resolve({
            type: 'centerWeightView2Test2/getTmsData',
            payload: { scanSite },
          });

          Array.prototype.push.apply(actualCars, actualDepartureCarsItem);
          Array.prototype.push.apply(planCars, planDepartureCarsItem);
        }

        //#region 已装未发 通过tms实际出发和预计出发任务号查询 druid装车数据,两种数据相减
        let departureTaskNos = actualCars.map((item) => item.taskNo); // 实际发车TMS任务号
        let departureTaskNos_plan = planCars.map((item) => item.taskNo);
        departureTaskNos_plan = lodash.uniqWith(departureTaskNos_plan, lodash.isEqual); // 计划发车TMS任务号
        // 将实际发车从计划发车中排除; 0 实际发车, 1计划发车
        const planLoadTaskNos = departureTaskNos_plan.filter((item) => {
          const finds = departureTaskNos.find((item2) => item === item2);
          return !finds;
        });
        const departureFilter = actualDepartureQuery({
          // 实际发车查实际表, 计划发车查计划表
          scanSite: scanSiteArr,
          startDate: query.startDate,
          endDate: query.endDate,
          taskNos: departureTaskNos,
          taskNos_plan: planLoadTaskNos,
        });

        const actualLoadData = yield call(getData_Vehicle, departureFilter[0]);
        //#endregion

        // 合并数据
        allSite.forEach((item, index) => {
          item.index = index;
          // 去除下一站所属省的 省区/经营本部后缀
          let nextProvinceArea = nextOperatingAreas
            .get(item.nextSite)
            ?.provinceAreaName.replace(/分拨中心|经营本部|省区|营运区|管理区/g, '');
          item.nextProvinceArea = nextProvinceArea;
          // 拼接流向(计划表: 当前站 -下一站)
          const nextSite = item.nextSite.replace('分拨中心', '');
          const scanSite = item.scanSite.replace('分拨中心', '');
          item.site = `${item.scanSite.replace('分拨中心', '')}-${nextSite}`;
          // 已装未发
          let mergeCars = {};
          actualLoadData.filter((item2) => {
            // 根据任务号进行匹配流向,存在多任务号相同流向需要合并
            const condit = item2.nextSite === item.nextSite && item.scanSite === item2.scanSite;

            if (condit) {
              if (!mergeCars.scanSite) {
                mergeCars = { ...item2, loadNoSendTaskNo: [], calcWeight: 0 };
              }
              mergeCars.calcWeight += item2.calcWeight;
              mergeCars.loadNoSendTaskNo.push(item2.taskNo);
            }
            return condit;
          });
          item.mergeCalcWeight = mergeCars.calcWeight ? computeWeights(mergeCars.calcWeight) : 0;
          item.loadNoSendTaskNo = mergeCars.loadNoSendTaskNo;
          // 规划运力
          let volumes = query.volumeItem.find(
            (item2) => nextSite === item2.arrivalCenter && scanSite === item2.departureCenter,
          );
          item.volumes = volumes ? volumes.volumes : 0;
          // 实际运力
          let actualVolumes = query.actualVolumeList.find(
            (item2) => nextSite === item2.arrivalCenter && scanSite === item2.departureCenter,
          );
          item.actualVolumes0 = actualVolumes ? actualVolumes.actualVolumes[0] : 0;
          item.actualVolumes1 = actualVolumes ? actualVolumes.actualVolumes[1] : 0;
          // 计划发车时间
          item.planTime2 = actualVolumes?.departureTime || '--';
          // 赋值数据
          results.forEach((item2, index2) => {
            const obj = item2.find(
              (itm2) => itm2.nextSite === item.nextSite && itm2.scanSite === item.scanSite,
            );
            item[`calcWeight${index2}`] = obj ? obj.calcWeight : 0;
          });
          // 天象
          // let obj = maxStockData.find(itm2 => itm2.nextSiteName === item.nextSite);
          // item.maxStockCalcWeight = obj ? obj.calcWeight : 0;
          // 按天统计库
          // obj = oneDayStock.find(itm2 => itm2.nextSite === item.nextSite && itm2.scanSite === item.scanSite);
          // item.dayStockCalcWeight = obj ? obj.calcWeight : 0;
        });

        // 计算合并后数据
        let sum = 0;
        allSite.forEach((item) => {
          // 网点预到达
          const siteSum = computeWeightNotAbs((item.calcWeight0 || 0) - (item.calcWeight1 || 0));
          item.originCalcWeight = siteSum < 0 ? 0 : siteSum;
          // 中转预到达
          const centerSum = computeWeightNotAbs((item.calcWeight2 || 0) - (item.calcWeight3 || 0));
          item.trainsCalcWeight = centerSum < 0 ? 0 : centerSum;
          // 库存
          const stockSum = computeWeightNotAbs((item.calcWeight4 || 0) + (item.calcWeight5 || 0));
          item.unloadedCalcWeight = stockSum < 0 ? 0 : stockSum;
          // 7日库存
          sum = computeWeightNotAbs(item.calcWeight6 + item.calcWeight7);
          item.stock7 = sum < 0 ? 0 : sum;

          // 天象库存
          item.maxStock = computeWeightNotAbs(item.dayStockCalcWeight);
          // 按天统计表库存
          // item.oneDayStock = item.dayStockCalcWeight < 0 ? 0 : computeWeightNotAbs(item.dayStockCalcWeight)

          // 出发合计 在库 + 干线预到达 + 网点预到达 + 已装未发
          // 在库 unloadedCalcWeight  干线预到达 trainsCalcWeight  网点预到达 originCalcWeight
          // 已装未发 mergeCalcWeight   预出发合计= 在库+干线预到达+网点预到达+已装未发
          const setTotal =
            Number(item.unloadedCalcWeight) +
            Number(item.originCalcWeight) +
            Number(item.mergeCalcWeight) +
            Number(item.trainsCalcWeight);
          item.setTotal = Number.parseFloat(setTotal.toFixed(1));
          const actualVolumesSum = item.actualVolumes0 + item.actualVolumes1 || 0;
          item.gapVolume = Number.parseFloat((Number(actualVolumesSum) - setTotal).toFixed(1));
        });
        //#endregion
      }

      const totalRow = {
        totalRow: '合计',
        sum0: 0,
        sum1: 0,
        sum2: 0,
        sum3: 0,
        sum4: 0,
        sum5: 0,
        sum6: 0,
        sum7: 0,
        sum8: 0,
      };
      allSite.forEach((item, index) => {
        totalRow.sum0 += item.originCalcWeight; // 网点预到达
        totalRow.sum1 += item.trainsCalcWeight; // 中转预到达
        totalRow.sum2 += item.unloadedCalcWeight; // 库存
        totalRow.sum3 += item.mergeCalcWeight; // 已装未发
        totalRow.sum4 += item.setTotal; // 预出发合计
        totalRow.sum5 += item.volumes; // 规划运力
        totalRow.sum6 += item.actualVolumes0; // 实际运力-正班车
        totalRow.sum7 += item.actualVolumes1; // 实际运力-加班车
        totalRow.sum8 += item.gapVolume; // 运力缺口
      });
      yield put({
        type: 'update',
        payload: {
          tableItem: allSite,
          totalRow,
        },
      });

      // yield put({ type: 'update', payload: { tableItem: allSite } });
      // yield put({ type: 'getStockData', payload: { siteNames, tableItem: data } });
    },
    *getStockData({ payload: { siteNames, tableItem } }, { call, put, select }) {
      let query = yield select(({ centerWeightView2Test2 }) => {
        return {
          centerFilter: centerWeightView2Test2.centerFilter,
          startDate: moment(centerWeightView2Test2.dateRange[0]).format(
            centerWeightView2Test2.defualtDateFormat,
          ),
          endDate: moment(centerWeightView2Test2.dateRange[1]).format(
            centerWeightView2Test2.defualtDateFormat,
          ),
          currentStartTime:
            centerWeightView2Test2.crrentDateRange &&
            moment(centerWeightView2Test2.crrentDateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
          currentEndTime:
            centerWeightView2Test2.crrentDateRange &&
            moment(centerWeightView2Test2.crrentDateRange[1]).format('YYYY-MM-DD HH:mm:ss'),
          datadbName: centerWeightView2Test2.datadbName,
        };
      });

      let sliceLen = 5; // 每次查询下一站个数
      for (let i = 0; i < siteNames.length; i = i + sliceLen) {
        // for (let i = 0; i < 1; i = i + sliceLen) {
        const siteNameSlice = siteNames.slice(i, i + sliceLen);
        // let sliceLen = 5  // 每次查询下一站个数
        // for (let i = 0, j = 1; i < siteNames.length; i = i + (sliceLen * j), j = j + 1) {
        //   const siteNameSlice = siteNames.slice(i, i + (sliceLen * j))
        const praram = {
          scanSite: query.centerFilter,
          startDate: query.startDate,
          currentStartTime: query.currentStartTime,
          currentEndTime: query.currentEndTime,
          endDate: query.endDate,
          siteNames: siteNameSlice,
        };
        const [unloadFilter, loadFilter] = PlanDepartureStockQuery(praram);
        const unloadData = yield call(getData_Vehicle, unloadFilter, query.datadbName);
        const waybillNos = unloadData.map((unloadItem) => unloadItem.waybillNo);
        loadFilter.inFilters = [
          { key: 'waybillNo', value: waybillNos },
          { key: 'planNextSite', value: siteNameSlice },
        ];
        const loadData = yield call(getData_Vehicle, loadFilter, query.datadbName);
        let aggStockData = unloadData.map((unItem) => {
          let { nextSite, waybillNo, calcWeight } = unItem;
          const loadFind = loadData.find(
            (loadItem) =>
              unItem.waybillNo === loadItem.waybillNo && unItem.nextSite === loadItem.planNextSite,
          );
          if (!!loadFind) {
            calcWeight = calcWeight + loadFind.calcWeight;
          }
          return { nextSite, waybillNo, calcWeight };
        }); //.filter(m => m.calcWeight > 0)

        const groupData = groupBys([...aggStockData], 'nextSite');
        // console.log('----', Object.keys(groupData))
        siteNameSlice.forEach((site, idx) => {
          const tempArr = groupData[site] ? aggreArrItem(groupData[site], ['calcWeight']) : {};
          // console.log('-------', site, tempArr)
          tableItem[i + idx].waybillNoStock =
            tempArr.calcWeight > 0 ? computeWeightNotAbs(tempArr.calcWeight) : 0;

          // const item = tableItem[i + idx]
          // const calc = (item.calcWeight4 || 0) + (item.calcWeight5 || 0);
          // tableItem[i + idx].diffWay = computeWeightNotAbs(tempArr.calcWeight - calc)
        });
        yield put({ type: 'update', payload: { tableItem: tableItem } });
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
